import {Div, HeaderBack, Label} from 'components';
import {Ecolors} from 'constant';
import React, {useEffect} from 'react';
import {ScrollView} from 'react-native-gesture-handler';
import {useSafeAreaInsets} from 'react-native-safe-area-context';
import {useDispatch} from 'react-redux';
import {loadWalletBounty} from 'reducer/asset';
import ComBubble from './ComBubble';
import ListSuggestInvest from './ListSuggestInvest';
import OverviewCom from './OverviewCom';
import RegulationCom from './RegulationCom';

function EventRewardScreens() {
  const insets = useSafeAreaInsets();
  const dispatch = useDispatch();

  useEffect(() => {
    getData();
    return () => {};
  }, []);

  const getData = () => {
    dispatch(loadWalletBounty({}));
  };

  return (
    <Div flex={1} backgroundColor={Ecolors.whiteColor}>
      <HeaderBack type={2} title={`eventreward.chuongtrinhlantoa`} />
      <ScrollView showsVerticalScrollIndicator={false}>
        <Div paddingHorizontal={20} paddingTop={16}>
          <Label
            size={24}
            fontWeight="bold">{`eventreward.lantoabanbevanhanthuong`}</Label>
          <ComBubble />
          <RegulationCom />
          <OverviewCom />
        </Div>
        <ListSuggestInvest />
        <Div height={insets.bottom + 20} />
      </ScrollView>
    </Div>
  );
}
export default React.memo(EventRewardScreens);
